
import { defineComponent, PropType } from "vue";
import { MdModal, MdModalComponentMixin } from "@/components/md/MdDialog";
import { MdButton } from "@/components/md/MdButton";
import { useStore } from "@/store";
import { InboxStore, RootStore } from "@/store/constants";
import { MdInputField } from "@/components/md/MdInput";
import { Validator } from "@/classes/validators/Validator";
import { TextValidator } from "@/classes/validators/TextValidator";
import { ITag } from "@/types/inbox/tags";
import EmptyHint from "@/components/cc/EmptyHint/EmptyHint.vue";
import MdCheckbox from "@/components/md/MdCheckbox/MdCheckbox.vue";
import MdBadge from "@/components/md/MdBadge/MdBadge.vue";
import { ICustomView } from "@/types/inbox/views";
import { updateView } from "@/api/inbox/settings/views/update";
import { MdRadio } from "@/components/md/MdRadio";

export default defineComponent({
  name: "ViewUpdateModal",
  mixins: [MdModalComponentMixin],
  components: {
    MdBadge,
    MdCheckbox,
    EmptyHint,
    MdModal,
    MdButton,
    MdInputField,
    MdRadio,
  },
  props: {
    view: Object as PropType<ICustomView>,
  },
  data() {
    return {
      name: "",
      selectedTags: [] as string[],
      selectedFields: [] as string[],
      selectedSort: "" as string,
    };
  },
  setup() {
    return {
      store: useStore(),
    };
  },
  watch: {
    view() {
      if (!this.view) return;
      this.name = this.view.name;
      this.selectedTags = this.view.tags || [];
      this.selectedFields = this.view.fields || [];
      this.selectedSort = this.view.sort || "none";
    },
  },
  computed: {
    nameInput(): typeof MdInputField {
      return this.$refs.nameInput as typeof MdInputField;
    },
    nameValidator(): Validator {
      return new TextValidator(true);
    },
    tags(): ITag[] | null {
      return this.store.getters[InboxStore.Getters.GET_TAGS];
    },
    fields(): { name: string; value: string; color: string }[] {
      return [
        {
          name: "Ungelesen",
          value: "unread",
          color: "grey",
        },
      ];
    },
    sorts(): { name: string; id: string }[] {
      return [
        { name: "Unsortiert", id: "none" },
        { name: "Aktivität", id: "updated" },
      ];
    },
  },
  methods: {
    getColor(colorName: string) {
      return this.store.getters[InboxStore.Getters.GET_TAG_COLOR](colorName)
        .color;
    },
    async updateView() {
      this.nameInput.validate();
      if (!this.nameValidator.isValid()) return;
      this.setLoadingState(true);
      if (!this.view || !this.view.id) return;
      try {
        await updateView(
          this.view.id,
          this.name,
          this.selectedTags,
          this.selectedFields,
          this.selectedSort
        );
        this.store.dispatch(InboxStore.Actions.LOAD_VIEWS);
        this.store.commit(RootStore.Mutations.SET_SNACKBAR, {
          state: "success",
          content: "Änderungen gespeichert",
        });
      } catch (err) {
        this.store.commit(RootStore.Mutations.SET_SNACKBAR, {
          state: "error",
          content: "Ansicht konnte nicht gespeichert werden",
        });
      }
      this.name = "";
      this.setLoadingState(false);
      this.close();
    },
  },
});
